import React from "react";
import ConfigurableItem from "./ConfigurableItem";

const Configurables = ({ t, product, onChangeConfigurableProduct }) => {
  const changeOptionHandler = (option) => {
    // Trigger the change event for the configurable product to update the UI with the new product data
    onChangeConfigurableProduct({ ...product?.current_option, ...option });
  };

  return (
    <>
      {product?.configurable_options?.length > 0 && (
        <>
          {product?.configurable_options?.map((config, i) => (
            <ConfigurableItem
              key={i}
              t={t}
              title={config?.label}
              options={config?.options}
              currentOption={product?.current_option}
              onChangeCurrentOption={changeOptionHandler}
            />
          ))}
        </>
      )}
    </>
  );
};

export default Configurables;
